export default __webpack_public_path__ + "static/media/systemEntranceCercle_black.59bd2568.svg";